import React, { useState, useEffect, useRef } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon } from "@fortawesome/free-solid-svg-icons";

import "./checkin-checkout-calender.css";

import _ from "lodash";
import moment from "moment";

const format = "MMM DD, YYYY";

/** Main Component Function */
function CheckInCheckOutCalender({
  searchCriteria = {},
  setSearchCriteria,
  setErrors,

  isView = false,
}) {
  const bookingDates = _.cloneDeep(searchCriteria.bookingDates);

  const [isOpened, setIsOpened] = useState(false);

  const checkinDate = bookingDates?.checkinDate;
  const checkoutDate = bookingDates?.checkoutDate;

  const [tooltip, setTooltip] = useState();
  const ref = useRef();

  //when the compoent loades
  useEffect(() => {
    let _checkin = moment(checkinDate);
    let _checkout = moment(checkoutDate);

    if (_checkin.isValid()) {
      if (!_checkout.isValid() || !_checkin.isAfter(_checkout)) {
        _checkout = _checkin.clone().add(1, "day");
      }

      _checkin = _checkin.format("YYYY-MM-DD");
      _checkout = _checkout.format("YYYY-MM-DD");

      setSearchCriteria((prev) => ({
        ...prev,
        bookingDates: {
          checkinDate: _checkin,
          checkoutDate: _checkout,
        },
      }));
    }
  }, []);
  // location.pathname, location.search

  let noOfNights = moment(checkoutDate).diff(moment(checkinDate), "days");

  if (noOfNights < 0) {
    noOfNights = 0;
  }

  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash !== "#overlay" && isOpened) {
        setIsOpened(false);
        ref.current.closeCalendar();
      }
    };

    if (isOpened) {
      window.history.pushState(null, null, "#overlay");
      // } else {
      //   window.history.replaceState(
      //     null,
      //     null,
      //     window.location.pathname + window.location.search
      //   );
    }
    function handleFocusIn(event) {
      const target = event.target;

      if (!isOpened) return;

      if (target.id !== "date-picker") {
        setIsOpened(false);
        ref.current.closeCalendar();
      }
    }

    document.addEventListener("focusin", handleFocusIn);
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [isOpened]);

  const checkValidationOnCalendarClose = (props) => {
    setIsOpened(false);

    setTooltip((prev) => ({ ...prev, visible: false }));

    if (!moment(checkinDate).isValid()) {
      setErrors((prev) => ({
        ...prev,
        bookingDates: "Please select dates",
      }));
      return;
    }
  };

  const handleDateChange = (dates = [], e) => {
    // // start and end date cannot be same
    if (dates.length === 2 && dates[0].toDays() === dates[1].toDays()) {
      dates.pop();
    }

    const checkinDate = dates[0] ? moment(dates[0].format(format)).format("YYYY-MM-DD") : null;
    const checkoutDate = dates[1] ? moment(dates[1].format(format)).format("YYYY-MM-DD") : null;

    setSearchCriteria((prev) => ({
      ...prev,
      bookingDates: {
        checkinDate,
        checkoutDate,
      },
    }));

    // check if user has selected both dates
    if (dates.length >= 2) {
      // close the calendar
      ref.current.closeCalendar();

      setErrors((prev) => ({ ...prev, bookingDates: null }));
      setIsOpened(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        if (checkinDate && !checkoutDate) {
          const selectedDate = checkinDate;
          const nextDay = moment(selectedDate).add(1, "day").format("YYYY-MM-DD");

          setSearchCriteria((prev) => ({
            ...prev,
            bookingDates: {
              checkinDate: selectedDate,
              checkoutDate: nextDay,
            },
          }));

          setErrors((prev) => ({ ...prev, bookingDates: null }));
          // close the calendar
          ref.current.closeCalendar();
        }
      }
    }

    document.addEventListener("click", handleClickOutside);

    let noOfNights = moment(checkoutDate).diff(moment(checkinDate), "days");

    const isCheckoutGreater = moment(checkoutDate).isAfter(moment(checkinDate));

    if (noOfNights < 90 || isCheckoutGreater) {
      setErrors((prev) => ({ ...prev, bookingDates: null }));
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [searchCriteria.bookingDates]);

  const today = new Date();
  const nextYear = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());

  const handleRemoveDates = () => {
    setSearchCriteria((prev) => ({
      ...prev,
      bookingDates: {
        checkinDate: null,
        checkoutDate: null,
      },
    }));
    setErrors((prev) => ({ ...prev, bookingDates: null }));
    ref.current.closeCalendar();
  };

  const checkInDate = bookingDates.checkinDate;
  const checkOutDate = bookingDates.checkoutDate;

  return (
    <div
      className={`${"outer-div-main position-relative date-picker-main"}`}
      style={{
        position: "relative",
      }}
    >
      <DatePicker
        // add the time zone
        id="date-picker"
        timeZone="UTC"
        minDate={today}
        maxDate={nextYear}
        value={Object.values(bookingDates).map((date) => (date ? new DateObject(date) : null)) || []}
        onChange={handleDateChange}
        onOpen={() => {
          setIsOpened(true);
        }}
        multiple
        sort
        format={format}
        placeholder="Check in - Check out"
        numberOfMonths={2}
        range
        rangeHover
        isClearable={true}
        onClose={checkValidationOnCalendarClose}
        inputClass={`input-class-main-search ${isView ? "transparent-background" : ""}`}
        arrow={false}
        calendarPosition="bottom-left"
        offsetY={35}
        fixMainPosition={true}
        // className="outer-div-main"
        // rangeHover={true}
        // markFocused={true}

        ref={ref}
        mapDays={(prop) => {
          const { date, today, selectedDate } = prop;
          let diff = Math.abs(date.toDays() - selectedDate[0]?.toDays());

          return {
            onMouseOver: (e) => {
              let spanRect = e.target.getBoundingClientRect();
              const rect = ref.current.getBoundingClientRect();

              const isOpenedInTop = rect.top < window.innerHeight / 2;

              let isDisabledSpan = e.target.offsetParent.className.includes("rmdp-disabled");

              let calendarRect = ref.current.querySelector(".rmdp-wrapper").getBoundingClientRect();

              if (!checkoutDate && !isDisabledSpan) {
                setTooltip((prev) => {
                  return {
                    ...prev,
                    left: spanRect.left - calendarRect.left,
                    top: spanRect.top - calendarRect.top - 58,

                    visible: diff ? true : false,
                    diff,
                  };
                });
              }
            },

            onMouseLeave: () => {
              setTooltip((prev) => ({
                ...prev,
                visible: false,
                diff,
              }));
            },
          };
        }}
      >
        {tooltip?.visible && (
          <span
            className="datePicker-tooltip"
            style={{
              top: `${tooltip.top + 20}px`,
              left: `${tooltip.left - 9}px`,
            }}
          >
            {tooltip.diff} {tooltip.diff > 1 ? "nights" : "night"}
          </span>
        )}
      </DatePicker>
      {checkInDate && checkOutDate && (
        <button onClick={handleRemoveDates} className="main-date-cancel-button">
          <svg width="24px" height="24px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#000000" className="main-date-cancel">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                fill="grey"
                d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
              ></path>
            </g>
          </svg>
        </button>
      )}

      <FontAwesomeIcon icon={faMoon} size="xl" className={`home-background-align-self-center moon ${isView ? "moon-trasperent" : ""}`} />
      <span className="calender-days-main-search">{noOfNights || 0}</span>
    </div>
  );
}

export default CheckInCheckOutCalender;
